import Vue from 'vue'
import Vuex from 'vuex'

import getters from './getters'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        // Default Inmutable settings
        activityTypes: [
            'Teoría',
            'Práctica',
            'Laboratorio',
            'Otro'
        ],
        weekdays: [
            'Lunes',
            'Martes',
            'Miércoles',
            'Jueves',
            'Viernes',
            'Sábado',
            'Domingo'
        ],
        careerList: [
            'Biología',
            'Computación',
            'Geoquímica',
            'Física',
            'Matemática',
            'Química'
        ],
        courseTypeList: [
            'Obligatoria',
            'Electiva',
            'Obligatoria optativa',
            'Complementaria',
            'Otra'
        ],
        courseClassificationList: [
            'Semestre I',
            'Semestre II',
            'Semestre III',
            'Semestre IV',
            'Semestre V',
            'Semestre VI',
            'Semestre VII',
            'Semestre VIII',
            'Semestre IX',
            'Semestre X'
        ],
        userRoles: {
            administrator: 4,
            coordinator: 3,
            professor: 2,
            studentTeacher: 1,
            student: 0
        },
        notifications: {
            NOTICE: '0000001',
            FILE: '0000010',
            FORUM: '0000100',
            COMMENT: '0001000',
            ASSIGNMENT: '0010000',
            EVALUATION: '0100000',
            EVENT: '1000000'
        },
        coursesList: null,

        // HomePage settings
        homePageActiveCareer: 'Biología',
        currentPossibleSemesters: [],

        // User Credentials
        userToken: localStorage.getItem(process.env.VUE_APP_TOKEN_NAME) || '',
        userData: {
            id: null,
            identityCard: null,
            displayName: null,
            email: null,
            emailSettings: null,
            role: null,
            relatedSites: [],
            relatedRecentSites: []
        },

        // AdminPage settings
        adminPageActiveCareer: 'Biología',
        adminSelectedCourse: null,
        professorsList: null,
        adminSelectedProfessor: null,
        studentsList: null,
        adminSelectedStudent: null,

        // SitePage settings
        serverTime: null,
        activeSite: null,
        activeSitePreviousSemestersSites: null,
        activeSiteStudents: null,
        activeSiteTeacherSurveys: null,
        activeSiteStudentSurveys: null,
        activeSiteAssignments: null,
        activeSiteForumPosts: null,
        activeSiteLogs: null,
        activeSiteGrades: null,
        singleStudentGrades: null,

        // SitePages CRUD settings
        selectedCrudObject: null, // Used to display update/create/delete modals for every crud applicable object.
        selectedNewsObject: null, // Used to display news details modal.

        selectedCalendarDate: null,

        selectedSurveyObject: null,
        selectedSurveyQuestionId: null,

        selectedForumPostObject: null, // Used to display forum post details and comments modal.
        selectedForumPostComments: null, // Used to display forum post details and comments modal.

        selectedAssignment: null, // Used to display the student and teaching staff assignment file modals.

        loadingComponent: false
    },
    mutations,
    getters,
    actions,
    modules: {
    }
})
